import { PluginService } from "./constants";

import { DefaultPluginService } from "./plugin-service";

import { bindContributionProviderNoSingletonScope } from "../common/contribution-provider";

import { AutoEnablePlugins } from "./constants";

export function bindPluginModules({bind: bind}) {
    bind(PluginService).to(DefaultPluginService), bindContributionProviderNoSingletonScope(bind, AutoEnablePlugins);
}

export default bindPluginModules;
//# sourceMappingURL=plugin-modules.js.map
